import parse from "date-fns/parse";

const DATE_FNS_DATE_FORMAT = "dd-MM-yyyy";

interface DateInput {
  values: Record<string, string>;
}

export const sortDate = (a: DateInput, b: DateInput, columnId: string) => {
  const valueA = a.values[columnId];
  const valueB = b.values[columnId];

  if (valueA && !valueB) {
    return -1;
  }

  if (!valueA && valueB) {
    return 1;
  }

  if (!valueA && !valueB) {
    return 0;
  }

  const dateA = parse(valueA, DATE_FNS_DATE_FORMAT, new Date());
  const dateB = parse(valueB, DATE_FNS_DATE_FORMAT, new Date());

  return dateA.valueOf() - dateB.valueOf();
};

export type SortOrder = "ASC" | "DESC";

const SORT_OPTIONS = { numeric: true };

export const sortAlphabetically = (sortOrder: SortOrder, input: string[]) =>
  [...input].sort((a: string, b: string) =>
    sortOrder === "ASC" ? a.localeCompare(b, undefined, SORT_OPTIONS) : b.localeCompare(a, undefined, SORT_OPTIONS)
  );
